import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { http } from "@/lib/api";

const StockContext = createContext({ isSoldOut: () => false, refresh: () => {} });

export function StockProvider({ children }) {
  const [sold, setSold] = useState([]);
  const refresh = useCallback(() => {
    http.get("/stock").then((r) => setSold(Array.isArray(r.data?.sold_out) ? r.data.sold_out : [])).catch(() => {});
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  const value = useMemo(() => {
    const keys = new Set(sold.map((s) => `${s.product_id}|${s.shade}`));
    return { isSoldOut: (pid, shade) => keys.has(`${pid}|${shade}`), refresh };
  }, [sold, refresh]);
  return <StockContext.Provider value={value}>{children}</StockContext.Provider>;
}

export const useStock = () => useContext(StockContext);
